export default class Sticky {
  constructor($element) {
    this.$element = $element;
    this.$sensor = this.$element.parentNode.querySelector('.js-sticky-sensor');

    this.$observer = new IntersectionObserver(
      ([e]) => this.$element.classList.toggle('is-pinned', !e.isIntersecting),
      {thresold: 1.0}
    );

    this.$observer.observe(this.$sensor);
  }

}



// WEBPACK FOOTER //
// ./scripts/dom/Sticky.js